/**
 * Team member role constants
 */
export const TEAM_ROLES = {
  OWNER: 'owner',
  HIRING_MANAGER: 'hiring_manager',
  RECRUITER: 'recruiter',
  GUEST: 'guest',
} as const;

export type TeamRole = typeof TEAM_ROLES[keyof typeof TEAM_ROLES];

// Helper function to check if a role has admin privileges
export const hasAdminPrivileges = (role: TeamRole | string): boolean => {
  return role === TEAM_ROLES.OWNER || role === TEAM_ROLES.HIRING_MANAGER;
};
